export const getApiBase = () => {
	return (
		(typeof process !== "undefined" && process.env.BUN_PUBLIC_API_URL) ||
		""
	).replace(/\/$/, "");
};

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
	const token = localStorage.getItem("adafia_auth_token");

	const headers = new Headers(options.headers);
	if (token) {
		headers.set("Authorization", `Bearer ${token}`);
	}

	const response = await fetch(url, {
		...options,
		headers,
		credentials: "include", // Automatically send auth_token cookie if present
	});

	if (response.status === 401) {
		// Token might be expired or invalid
		localStorage.removeItem("adafia_auth_token");
	}

	return response;
};
